import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { apiErr } from "../lib/api";
import { toast } from "sonner";
import { Cross, Loader2 } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      toast.success("Berhasil masuk");
      navigate("/");
    } catch (err) {
      const msg = apiErr(err.response?.data?.detail) || err.message;
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:flex lg:w-1/2 relative bg-teal-900">
        <img
          src="https://images.unsplash.com/photo-1580281657527-47f249e8f4df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxob3NwaXRhbCUyMHBoYXJtYWN5JTIwbWVkaWNpbmUlMjBzdG9jayUyMGludmVudG9yeXxlbnwwfHx8fDE3ODcxMDU2MTZ8MA&ixlib=rb-4.1.0&q=85"
          alt="Farmasi Rumah Sakit"
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="relative z-10 flex flex-col justify-end p-12 text-white">
          <div className="h-12 w-12 rounded-2xl bg-white/15 backdrop-blur flex items-center justify-center mb-6">
            <Cross className="h-6 w-6 text-white" strokeWidth={2.5} />
          </div>
          <h1 className="font-head text-4xl font-extrabold leading-tight tracking-tight">
            Sistem Stock Opname<br />Farmasi Rumah Sakit
          </h1>
          <p className="mt-4 text-teal-50/80 text-sm max-w-md leading-relaxed">
            Kelola perhitungan fisik obat di setiap tempat penyimpanan, impor master obat via Excel,
            dan hasilkan laporan selisih siap ekspor.
          </p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8 bg-[#F8FAFC]">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-3 mb-8">
            <div className="h-10 w-10 rounded-xl bg-teal-700 flex items-center justify-center">
              <Cross className="h-5 w-5 text-white" strokeWidth={2.5} />
            </div>
            <span className="font-head font-extrabold text-slate-900">StockOpname</span>
          </div>

          <h2 className="font-head text-2xl font-bold text-slate-900">Masuk</h2>
          <p className="text-sm text-slate-500 mt-1 mb-8">Gunakan akun admin farmasi Anda.</p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs font-medium text-slate-600 uppercase tracking-wider">Email</label>
              <input
                data-testid="login-username-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="nama@email.com"
                className="mt-1.5 w-full rounded-lg border border-slate-300 px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-teal-600/40 focus:border-teal-600 transition-colors"
                required
              />
            </div>
            <div>
              <label className="text-xs font-medium text-slate-600 uppercase tracking-wider">Password</label>
              <input
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="mt-1.5 w-full rounded-lg border border-slate-300 px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-teal-600/40 focus:border-teal-600 transition-colors"
                required
              />
            </div>
            {error && <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</div>}
            <button
              data-testid="login-submit-button"
              type="submit"
              disabled={loading}
              className="w-full flex items-center justify-center gap-2 rounded-lg bg-teal-700 hover:bg-teal-800 text-white font-semibold text-sm py-2.5 transition-colors duration-150 disabled:opacity-60"
            >
              {loading && <Loader2 className="h-4 w-4 animate-spin" />}
              Masuk
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
